<template>
  <VcLayout class="embeddedAppsDisplay"
            v-show="displayedApp !== undefined" :data-qa="dataQa" column fill-height>
    <EmbeddedAppDelegator v-for="appId in liveApps" :key="appId"
                          v-show="appId === displayedApp"
                          v-bind="getAppData(getExternalAppById(appId))"
                          parentSource="EMB"/>
  </VcLayout>
</template>
<script>

/**
 * This is the container for the live embedded apps, which will always be on the DOM.
 * It's used in order to keep them alive on the DOM even when not displayed, until they are removed from the liveApp list.
 */

import { mapGetters } from 'vuex';
import EmbeddedAppDelegator from '@/modules/app/components/EmbeddedAppDelegator.vue';
import { getAppRouteData } from '../utils/appRouteData';

export default {
  name: 'EmbeddedAppsDisplay',
  components: { EmbeddedAppDelegator },
  props: {
    dataQa: {
      type: String,
      default: 'EmbeddedAppsDisplay',
    },
  },
  data() {
    return {
      observeContainer: null,
    };
  },
  created() {
    this.observeContainer = new ResizeObserver(this.calculateIframePosition);
  },
  computed: {
    ...mapGetters('AppStore', ['getExternalAppById']),
    ...mapGetters('AppStore/EmbeddedAppStore', ['liveApps', 'displayedApp', 'getAppRoute']),
  },
  watch: {
    displayedApp() {
      this.initResizeObserve();
    },
  },
  methods: {
    getAppData(app) {
      const url = this.getAppRoute(app.app_code_name);

      const appMenuData = this.getExternalAppById(this.displayedApp);
      const appTitle = getAppRouteData(appMenuData, this.$router.currentRoute.params.route)?.key || app.app_name;
      return {
        component: 'iFrame',
        appId: app.app_code_name,
        appCodeName: app.app_code_name,
        appUrl: url.href,
        appName: app.app_name,
        appTitle,
        displayHeader: !!app.show_header,
      };
    },
    initResizeObserve() {
      if (this.displayedApp) {
        this.observeContainer.observe(document.querySelector('.LiveEmbeddedAppsPage'));
      } else {
        this.observeContainer.disconnect();
      }
    },
    calculateIframePosition() {
      const placeholder = document.querySelector('.LiveEmbeddedAppsPage');
      const placeholderLocation = placeholder.getBoundingClientRect();
      const embeddedAppIframe = document.querySelector('.embeddedAppContainer');

      embeddedAppIframe.style.top = `${placeholderLocation.top}px`;
      embeddedAppIframe.style.left = `${placeholderLocation.left}px`;
      embeddedAppIframe.style.width = `${placeholderLocation.width}px`;
      embeddedAppIframe.style.height = `${placeholderLocation.height}px`;
    },
  },
};
</script>

<style lang="scss" scoped>

.embeddedAppsDisplay {
  width: 100%;
  height: 100%;
}

</style>
